/*
 * SetView Messages
 *
 * This contains all the text for the SetView component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  meetingsPlanned: {
    id: 'app.components.SetView.meetingsPlanned',
    defaultMessage: '{count}/{total} meetings have been planned',
  },
  continue: {
    id: 'app.components.SetView.continue',
    defaultMessage: 'Continue Planning',
  },
  draft: {
    id: 'app.components.SetView.draft',
    defaultMessage: 'Draft',
  },
  options: {
    id: 'app.components.SetView.options',
    defaultMessage: 'Options',
  },
  cancel: {
    id: 'app.components.SetView.cancel',
    defaultMessage: 'Remove Planning',
  },
  noCancel: {
    id: 'app.components.SetView.noCancel',
    defaultMessage: 'You can only cancel if no meetings are planned yet',
  },
  registrationPeriod: {
    id: 'app.components.SetView.registrationPeriod',
    defaultMessage: 'Registration Period',
  },
  meetingsPeriod: {
    id: 'app.components.SetView.meetingsPeriod',
    defaultMessage: 'Meetings Period',
  },
  notSet: {
    id: 'app.components.SetView.notSet',
    defaultMessage: 'Not set yet',
  },
  startRegistration: {
    id: 'app.components.SetView.startRegistration',
    defaultMessage: 'Start Registration:',
  },
  endRegistration: {
    id: 'app.components.SetView.endRegistration',
    defaultMessage: 'Close Registration:',
  },
  firstMeeting: {
    id: 'app.components.SetView.firstMeeting',
    defaultMessage: 'First Meeting:',
  },
  lastMeeting: {
    id: 'app.components.SetView.lastMeeting',
    defaultMessage: 'LastMeeting:',
  },
  started: {
    id: 'app.components.SetView.started',
    defaultMessage: 'Started',
  },
  closed: {
    id: 'app.components.SetView.closed',
    defaultMessage: 'Closed',
  },
  openEnd: {
    id: 'app.components.SetView.openEnd',
    defaultMessage: 'After last meeting',
  },
  updateGeneral: {
    id: 'app.components.SetView.updateGeneral',
    defaultMessage: 'General Settings',
  },
  updateStudents: {
    id: 'app.components.SetView.updateStudents',
    defaultMessage: 'Students',
  },
  updatePeriod: {
    id: 'app.components.SetView.updatePeriod',
    defaultMessage: 'Meetings Period',
  },
  updateAssign: {
    id: 'app.components.SetView.updateAssign',
    defaultMessage: 'Timeslots Assignment',
  },
  updateRegistration: {
    id: 'app.components.SetView.updateRegistration',
    defaultMessage: 'Registration Period',
  },
  overview: {
    id: 'app.components.SetView.overview',
    defaultMessage: 'Overview of meetings',
  },
  download: {
    id: 'app.components.SetView.download',
    defaultMessage: 'Download Planning',
  },
  removeTitle: {
    id: 'app.components.SetView.removeTitle',
    defaultMessage: 'Remove Planning',
  },
  remove: {
    id: 'app.common.remove',
    defaultMessage: 'Remove',
  },
  removeMessage: {
    id: 'app.components.SetView.removeMessage',
    defaultMessage: 'Remove planning "{title}"?',
  },
  removePrompt: {
    id: 'app.components.SetView.removePrompt',
    defaultMessage: 'Message to invited participants:',
  },
});
